import React from "react";
import { useTranslation } from "react-i18next";
import Grid from "~/components-shared/Grid";
import { Button, Card, Text } from "~/components-shared";
import styled from "styled-components";
import workingStyleQuestions from "~/lib/workingStyleQuestions";
const StyledButton = styled(Button)`
  width: 2.2rem;
  height: 2.2rem;
`;
const WorkingStyleForm = _ref => {
  let {
    watch,
    setValue,
    editing,
    workingStyle
  } = _ref;
  const {
    t
  } = useTranslation();
  const questions = workingStyleQuestions;
  const handleAnswerClick = (questionId, answerId) => {
    const answer = `${questionId}:${answerId}`;
    const answers = watch("workingStyleAnswers");
    if (answers.includes(answer)) {
      setValue("workingStyleAnswers", answers.filter(a => a !== answer));
    } else if (answers.some(option => option.includes(questionId))) {
      const filteredAnswers = answers.filter(option => !option.includes(questionId));
      setValue("workingStyleAnswers", [...filteredAnswers, answer]);
    } else {
      setValue("workingStyleAnswers", [...answers, answer]);
    }
  };
  return /*#__PURE__*/React.createElement("fieldset", null, editing && /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    lineHeight: 7,
    s: {
      mb: 5
    },
    display: "block"
  }, t("WorkingStyleForm.workingStyleDesc")), Object.keys(questions).map((questionKey, questionIndex) => /*#__PURE__*/React.createElement(Card, {
    key: questionKey,
    title: /*#__PURE__*/React.createElement(Text, {
      element: "h5",
      lineHeight: 7
    }, /*#__PURE__*/React.createElement(Text, {
      fontSize: 3.5,
      color: "textSecondary",
      weight: "semiBold"
    }, questionIndex + 1, "."), " ", questions[questionKey].title),
    s: {
      px: editing ? 4 : 0,
      mb: 8
    },
    fullWidth: true,
    border: editing
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    template: "1fr 2.2rem",
    gap: 3,
    align: "center",
    fullWidth: true
  }, Object.keys(questions[questionKey].answers).map((answerKey, answerIndex) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: answerKey
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 4,
    lineHeight: 7,
    s: {
      ml: 4,
      my: 0
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 3,
    color: "textSecondary",
    weight: "semiBold"
  }, questionIndex + 1, ".", answerIndex + 1, "."), " ", questions[questionKey].answers[answerKey]), editing ? /*#__PURE__*/React.createElement(StyledButton, {
    color: "grey",
    fontSize: 5,
    s: {
      p: 0
    },
    onClick: () => handleAnswerClick(questionKey, answerKey)
  }, watch("workingStyleAnswers").includes(`${questionKey}:${answerKey}`) ? watch("selectedEmoji") || "➕" : "󠀠") : /*#__PURE__*/React.createElement(StyledButton, {
    color: "grey",
    fontSize: 5,
    s: {
      p: 0
    },
    disabled: !editing
  }, workingStyle.workingStyleAnswers.includes(`${questionKey}:${answerKey}`) ? workingStyle.selectedEmoji || "➕" : "󠀠")))))));
};
export default WorkingStyleForm;